module.exports = __webpack_public_path__ + "static/img/item-l_j_orange.a00d25c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_j_orange.png
// module id = kW2L
// module chunks = 1